import React from "react";

export const AdvanceShippingContext = React.createContext({});

export const AdvanceShippingProvider = AdvanceShippingContext.Provider;
